import { useState } from "react";
import { useAccountSetupTasks } from "../components/CompleteSetupTaskList";

/**
 * Account-setup gate for aviation BNPL (pay in installments).
 *
 * Searching, selecting a flight and paying from the wallet are open to every
 * customer. Installments need the whole setup checklist done, in its product
 * order. The customer is walked through it one step at a time: the gate dialog
 * names the first task while it is still outstanding, then points at the full
 * checklist for whatever is left.
 *
 * The backend keeps its own floor (FlightInstallmentEligibility) and refuses
 * installments with `INSTALLMENT_SETUP_INCOMPLETE` whatever this returns.
 */
const useBnplGate = () => {
  const { tasks, metric } = useAccountSetupTasks();
  const [isGateOpen, setIsGateOpen] = useState(false);
  const [isSetupListOpen, setIsSetupListOpen] = useState(false);

  const pendingTasks = tasks.filter((task) => !task.completed);
  const firstTask = tasks[0];

  return {
    isBnplAllowed: !metric.isLoading && pendingTasks.length === 0,
    isCheckingBnplAccess: metric.isLoading,
    /** The first task in product order, while it is still outstanding. */
    firstTaskPending: firstTask && !firstTask.completed ? firstTask : null,
    pendingTasks,
    isGateOpen,
    openGate: () => setIsGateOpen(true),
    closeGate: () => setIsGateOpen(false),
    isSetupListOpen,
    openSetupList: () => {
      setIsGateOpen(false);
      setIsSetupListOpen(true);
    },
    closeSetupList: () => setIsSetupListOpen(false),
  };
};

export default useBnplGate;
